import React from 'react';
import { Icon } from '@Sage/hoi-poi-ui';

const OpportunityIcon = ({ won, lost, expirationDays, className, size = 'medium' }) => {
    let icon = <Icon name="opportunities" size={size} />;

    if (won && (won === true || parseInt(won, 10) === 1)) {
        icon = <Icon name="opportunityThumbsUp" size={size} />;
    } else if (lost && (lost === true || parseInt(lost, 10) === 1)) {
        icon = <Icon name="opportunityThumbsDown" size={size} />;
    } else {
        if (expirationDays !== null && expirationDays <= 7) {
            if (expirationDays <= -100 || expirationDays <= -1) {
                icon = <Icon name="opportunityExpired" size={size} />;
            } else if (expirationDays >= 0) {
                icon = <Icon name="opportunityWarning" size={size} />;
            }
        }
    }

    return <div className={[className, 'entity-icon'].join(' ')}>{icon}</div>;
};

export default OpportunityIcon;
